import './input.css'

const ELEMENT_NAME = 'wp-input'

/**
 * A custom web component representing an Input
 *
 * Usage:
 * Just CSS:
 * ```html
 * <input type="text">
 * ```
 *
 * ```html
 * <wp-input></wp-input>
 * ```
 *
 * You can also create it programmatically:
 * ```js
 * const container = new Input();
 * document.body.appendChild(container);
 * ```
 */
export default class Input extends HTMLElement {
  static observedAttributes = ['label', 'style']

  static defaultTag = ELEMENT_NAME

  constructor () {
    super()

    this.$componentInfo = {
      // Component specific state
      elementId: `${ELEMENT_NAME}_` + Math.random().toString(36).substring(2, 9)
    }
  }

  connectedCallback () {
    console.log(`Custom element added to page: ${ELEMENT_NAME} id=${this.$componentInfo.elementId}`)
    this.render()
  }

  disconnectedCallback () {
    // Remove listener when Button is removed
  }

  render () {
    this.setAttribute('data-id', this.$componentInfo.elementId)
  }
}

if (!customElements.get(ELEMENT_NAME)) {
  customElements.define(ELEMENT_NAME, Input)
}
